import { Nullable } from '@clearverify/types';

import { StripeAccountStatus, useStripeGetAccountInfoQuery } from 'src/api';

export const useStripeAccount = (stripeAccountId?: Nullable<string>) => {
  const { data, loading } = useStripeGetAccountInfoQuery({
    variables: {
      stripeAccountId: stripeAccountId || '',
    },
    skip: !stripeAccountId,
  });

  return {
    stripeAccountStatus: data?.stripeGetAccountInfo.status || StripeAccountStatus.NotConnected,
    loading,
  };
};
